/* eslint-disable max-classes-per-file */
import { CommandBase } from "~app/common/services/cqs/commandManager";

export class TaBortGrotatgardCommand extends CommandBase {

    payload: TaBortGrotatgardDto;

    constructor(init: (instance: TaBortGrotatgardCommand) => void) {
        super("TaBortGrotatgardCommand");
        init(this);
    }
}

export class TaBortGrotatgardDto {
    atgardId: number;
    arbetsorderId: number;

    constructor(atgardId: number, arbetsorderId: number) {
        this.arbetsorderId = arbetsorderId;
        this.atgardId = atgardId;
    }
}
